export default __webpack_public_path__ + "vertical-ellipsis.png";